export default "__VITE_ASSET__ExNZEoSN__"